"use client";
import {
  createStore,
  throwOnConflictingProps
} from "../__chunks/XTZ53NXG.js";
import {
  defaultValue
} from "../__chunks/UWJK2WK2.js";

// src/checkbox/checkbox-store.ts
function createCheckboxStore(props = {}) {
  var _a;
  throwOnConflictingProps(props, props.store);
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const initialState = {
    value: defaultValue(
      props.value,
      syncState == null ? void 0 : syncState.value,
      props.defaultValue,
      false
    )
  };
  const checkbox = createStore(initialState, props.store);
  return {
    ...checkbox,
    setValue: (value) => checkbox.setState("value", value)
  };
}
export {
  createCheckboxStore
};
